import { render, staticRenderFns } from "./addcommercial_jbxx_edit.vue?vue&type=template&id=58e55d46&scoped=true&"
import script from "./addcommercial_jbxx_edit.vue?vue&type=script&lang=js&"
export * from "./addcommercial_jbxx_edit.vue?vue&type=script&lang=js&"
import style0 from "./addcommercial_jbxx_edit.vue?vue&type=style&index=0&id=58e55d46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e55d46",
  null
  
)

export default component.exports